// Modules
import { useFormContext } from "react-hook-form"

// Components
import Input from "~app/Input"
import FileUpload from "~components/FileUpload"
import { InputLabel } from "~styled/input"
import { ButtonFormContainer, ButtonFormSelection } from "~styled/button"
import { WizardRow, WizardColumn, WizardStepContainer } from "~styled/wizard"

interface StepProps {
  disabled: boolean
  isVisible: boolean
  isEditMode?: boolean
}

const PerkModalStep4CouponList = ({
  disabled,
  isVisible = true,
  isEditMode = false,
}: StepProps) => {
  const { watch, register, setValue, unregister } = useFormContext()

  const showUniqueCodeInput = watch("isUniqueCode")
  const skipCouponEdit = watch("skipCouponEdit")

  // While editing, the coupon inputs are only shown when the user explicitly
  // opts to edit the codes. In create mode they are always shown.
  const showCouponInputs = !isEditMode || !skipCouponEdit

  const changeCodeType = (event, isUnique: boolean) => {
    event.preventDefault()
    if (!disabled) {
      setValue("isUniqueCode", isUnique)
    }
  }

  const changeSkipCouponEdit = (event, skip: boolean) => {
    event.preventDefault()
    if (!disabled) {
      setValue("skipCouponEdit", skip)
    }
  }

  return (
    <WizardStepContainer className={isVisible ? "visible" : ""}>
      {isEditMode && (
        <WizardRow style={{ marginBottom: 30 }}>
          <WizardColumn>
            <InputLabel>Coupon codes</InputLabel>

            <ButtonFormContainer>
              <input
                {...register("skipCouponEdit")}
                type="checkbox"
                style={{ display: "none" }}
              />

              <ButtonFormSelection
                style={{ marginRight: 10 }}
                onClick={event => changeSkipCouponEdit(event, true)}
                disabled={disabled}
                className={skipCouponEdit ? "active" : ""}
              >
                Keep existing codes
              </ButtonFormSelection>

              <ButtonFormSelection
                onClick={event => changeSkipCouponEdit(event, false)}
                disabled={disabled}
                className={!skipCouponEdit ? "active" : ""}
              >
                Edit codes
              </ButtonFormSelection>
            </ButtonFormContainer>
          </WizardColumn>
        </WizardRow>
      )}

      {showCouponInputs && (
        <>
          <WizardRow style={{ marginBottom: 30 }}>
            <WizardColumn>
              <InputLabel>Code type</InputLabel>

              <ButtonFormContainer>
                <input
                  {...register("isUniqueCode")}
                  type="checkbox"
                  style={{ display: "none" }}
                />

                <ButtonFormSelection
                  style={{ marginRight: 10 }}
                  onClick={event => changeCodeType(event, false)}
                  disabled={disabled}
                  className={!showUniqueCodeInput ? "active" : ""}
                >
                  Multiple codes
                </ButtonFormSelection>

                <ButtonFormSelection
                  onClick={event => changeCodeType(event, true)}
                  disabled={disabled}
                  className={showUniqueCodeInput ? "active" : ""}
                >
                  Unique code
                </ButtonFormSelection>
              </ButtonFormContainer>
            </WizardColumn>
          </WizardRow>

          <WizardRow>
            {/* Multiple Codes */}
            {!showUniqueCodeInput && (
              <WizardColumn>
                <InputLabel style={{ marginBottom: 10 }}>
                  Upload coupon codes
                </InputLabel>

                <FileUpload
                  name="couponsFile"
                  accept=".csv"
                  disabled={disabled}
                  required={!disabled && !showUniqueCodeInput}
                  register={register}
                  setValue={setValue}
                  unregister={unregister}
                />
              </WizardColumn>
            )}

            {/* Generic Code */}
            {showUniqueCodeInput && (
              <WizardColumn>
                <Input
                  name="uniqueCode"
                  label="Insert unique coupon code"
                  disabled={disabled}
                  register={register("uniqueCode", {
                    required: !disabled && showUniqueCodeInput,
                  })}
                />
              </WizardColumn>
            )}
          </WizardRow>
        </>
      )}
    </WizardStepContainer>
  )
}

export default PerkModalStep4CouponList
